module.exports = __webpack_public_path__ + "static/media/IMG_8707.a97c1d26.JPG";